import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=22be5b60&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"
import style0 from "./Layout.vue?vue&type=style&index=0&id=22be5b60&prod&lang=css"
import style1 from "./Layout.vue?vue&type=style&index=1&id=22be5b60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22be5b60",
  null
  
)

export default component.exports